/**
 * 排課請求頁的分頁識別字，同時是網址上 `?tab=` 的值。
 *
 * 放在 constants 而不是頁面裡，是因為通知要能導向特定分頁 —— 兩邊必須用同一組字串，
 * 不可以各寫各的。
 */
export const COURSE_ASK_TAB = {
  NAMED_INVITATION: 'namedInvitation',
  BATCH_CLAIM: 'batchClaim',
  SINGLE_CLAIM: 'singleClaim',
} as const;

export type TCourseAskTab = typeof COURSE_ASK_TAB[keyof typeof COURSE_ASK_TAB];

/** 網址上的分頁參數名 */
export const COURSE_ASK_TAB_PARAM = 'tab';
